import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  fabMenuWrapper: {
    position: 'relative'
  },
  verticalContainer: {
    position: 'absolute',
    bottom: theme.spacing(6),
    left: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 1000,
    padding: theme.spacing(0.5),
    borderRadius: theme.spacing(1)
  },
  fabMenuButton: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  button: {
    margin: '4px',
    padding: '6px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_600.main
        : theme.palette.gray_100.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  micButton: {
    '&:hover': {
      color: theme.palette.green_200.main
    }
  },
  fileButton: {
    '&:hover': {
      color: theme.palette.blue_300.main
    }
  },
  emojiButton: {
    '&:hover': {
      color: theme.palette.yellow_400.main
    }
  },
  emojiBox: {
    position: 'absolute',
    bottom: '60px',
    left: '16px',
    zIndex: 1000,
  }
}))
